var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10421",
    "data-name": "Group 10421",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.227,
    height: 19.113,
    viewBox: "0 0 38.227 19.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2386",
    "data-name": "Rectangle 2386",
    width: 38.227,
    height: 19.113,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10420",
    "data-name": "Group 10420",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29381",
    "data-name": "Path 29381",
    d: "M11.468,9.557a1.912,1.912,0,0,0,1.911,1.911H24.848a1.911,1.911,0,1,0,0-3.823H13.379a1.912,1.912,0,0,0-1.911,1.911m3.823,5.734H9.557a5.734,5.734,0,1,1,0-11.468h5.734a1.911,1.911,0,1,0,0-3.823H9.557a9.557,9.557,0,0,0,0,19.113h5.734a1.911,1.911,0,0,0,0-3.823M28.67,0H22.936a1.911,1.911,0,1,0,0,3.823H28.67a5.734,5.734,0,1,1,0,11.468H22.936a1.911,1.911,0,1,0,0,3.823H28.67A9.557,9.557,0,1,0,28.67,0",
    transform: "translate(0 0)",
    fill: "#161615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.b6fa51ea8db35794a4e1a6e32b53a901.svg";
export { ForwardRef as ReactComponent };